import * as angular from "angular";

angular
  .module('bringoz.admin.planning')
  .constant('Draft_Routes_PN', {
    database: 'draftRoutes'
  });
